import { ReactNode } from "react";

export type ExoticTabContent = ((queryString?: string) => ReactNode) & {
  hidden?: boolean;
};
/*

overview
investment
operations
impact
analytics
team
gallery
notes
documents*/

export enum TabName {
  Overview = "overview",
  Diligence = "diligence",
  Investments = "investments",
  Analytics = "analytics",
  Team = "team",
  Gallery = "gallery",
  Notes = "notes",
  Afs = "afs",
  Documents = "documents",
  Guidelines = "guidelines",
  /** AFS, Guidelines and Notices, as sub-tabs. */
  Operations = "operations",
  Notices = "notices",
}
